import { Application, Feature, Functionality } from '@frontend/functionality/types';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { ApplicationBundleUsageLayout } from '../../components/application-bundle-usage-layout/application-bundle-usage-layout.component';
import { checkFeatureRoute, checkLicenseRoutes } from '../utils';
import LendingDashboard from './dashboard/dashboard.component';

const Inventory = lazy(() => import('./inventory/inventory.component'));
const Utilizations = lazy(() => import('./utilizations/utilizations.component'));
const CertifiedEquipment = lazy(() => import('./certified-equipments/certified-equipments.component'));
const Stock = lazy(() => import('./stock/stock.component').then((module) => ({ default: module.Stock })));
const Transactions = lazy(() => import('./transactions/transactions.component'));

export function ApplicationLendingRoutes(functionalities: Functionality[] | null) {
    const routeLicenseCheckResult = functionalities !== null ? checkLicenseRoutes(functionalities, Application.LENDING) : null;

    if (routeLicenseCheckResult && !routeLicenseCheckResult.appEnabled) {
        return null;
    }

    return (
        <Route
            path='lending'
            element={<ApplicationBundleUsageLayout application={Application.LENDING} />}>
            {checkFeatureRoute(Feature.DASHBOARD, routeLicenseCheckResult) && (
                <Route
                    path='dashboard'
                    element={<LendingDashboard />}
                />
            )}
            <Route
                path='inventory'
                element={<Inventory />}
            />
            <Route
                path='utilizations'
                element={<Utilizations />}
            />
            <Route
                path='certified_equipments'
                element={<CertifiedEquipment />}
            />
            <Route
                path='stock'
                element={<Stock />}
            />
            <Route
                path='transactions'
                element={<Transactions />}
            />
        </Route>
    );
}
